<!-- guest wishlist warning -->
@if (client.isL || client.isX) {
<product-layout-wishlist [product]="product()" />
}
<!-- label -->
<listing-label [customClass]="'inline-block left uppercase col-12 o1'"
               [product]="product()"
               [displayDefault]="true"
               [showFullLabel]="true" />
<!-- product name row -->
<div class="pos-relative flex flex-top flex-justify-between p-r-6-x p-r-8">
    <h1 class="inline-block h2-bold left">{{product().data?.name}}</h1>
    <product-layout-wishlist-toggle class="pos-absolute right-0 right--3-s"
                                    [productViewLayout]="productViewLayout()" />
</div>
<!-- price -->
<div class="m-t-1 p-b-1 left">
    <!-- price -->
    @if (product().orgPrice) {
    <product-price class="m-r-1 inline-block col-13 h3-bold line-through"
                   [product]="product()"
                   [orgPrice]="true" />
    }
    <product-price class="inline-block h3-bold"
                   [product]="product()" />
    <!-- price note (CMS managed) -->
    <span class="p2 col-13 p-l-2"
          *iCms="'priceNote' of content"></span>
</div>
<!-- Klarna note -->
@if (productViewLayout().showKlarna) {
<p class="c1"
   [innerHTML]="'Or % per month over 12 months. *Minimum spend £300' | translate : (product().price / 12 | price)">
</p>
}
@if (productViewLayout().parent()?.reviewsCount > 0) {
<product-layout-reviews [product]="product()"
                        [productViewLayout]="productViewLayout()"
                        [top]="true" />
}
@if (client.isS || client.isM) {
<!-- delivery messages -->
<product-layout-delivery-messages [product]="product()" />
@if (product().data?.category_ids?.includes(757)) {
<div class="bg-col-34 m-t-3 _custom-radius"
     *abIf="abShowCondition">
    <div class="s1 p-l-3 p-t-2">{{'Customise your bag with mix & match straps' | translate}}</div>
    <div class="p2 p-l-3 p-b-2">{{'Add your bag to basket then explore our styles' | translate}}</div>
</div>
}
}